// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";

import { getColor } from "../../../../libraries/wpl/foundations/src/index";

import { TabColorProps } from "./tab-group";

export const TabGroupStyle = css`
    ${UNSAFE_media.below.sm} {
        display: none;
    }
    .tab-group-inner {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 16px;
    }
`;

export const quoteSidebar = css`
    text-align: left;
`;

export const tabPanel = css`
    margin: 20px auto 0;
    &[aria-hidden="true"] {
        display: none;
    }
`;

export const contentBlockStyle = css`
    max-width: 100%;
    margin: 0 auto 24px;

    ${media.above.md} {
        width: 768px;
    }
`;

export const quote = (colors?: TabColorProps) => css`
    text-align: left;
    margin: 0 0 24px;
    padding: 30px 50px 30px 0;
    border-radius: 0 100px 100px 0 / 0 50% 50% 0;
    background-image: ${colors?.quoteColor
        ? `linear-gradient(90deg, transparent, ${getColor(colors.quoteColor)})`
        : "transparent"};

    .quote-blurb {
        margin-left: 0;
        font-size: 1.2rem;
        font-family: var(--bxp-charlie-display-font-family);
    }

    .quote-name {
        font-weight: bold;
        margin: 20px 0 0;
        text-transform: uppercase;
    }
    .quote-company {
        margin: 0;
        font-size: 0.875rem;
        text-transform: uppercase;
    }

    ${UNSAFE_media.below.sm} {
        display: none;
    }
`;

export const selectContainerStyle = (colors?: TabColorProps) => {
    return css`
        ${media.above.sm} {
            display: none;
        }

        .select-container-inner {
            position: relative;
            svg {
                position: absolute;
                right: 20px;
                top: 0;
                bottom: 0;
                margin: auto;
                color: ${getColor(
                    colors?.activeText ? colors.activeText : "n900"
                )};
            }
        }
    `;
};

export const tabStyle = (
    index: number,
    currentTab: number,
    colors?: TabColorProps
) => {
    const defaultBGColor = getColor(
        colors?.defaultBG ? colors.defaultBG : "n20"
    );
    const defaultTextColor = getColor(
        colors?.defaultText ? colors.defaultText : "n900"
    );
    const activeBGColor = getColor(colors?.activeBG ? colors.activeBG : "b75");
    const activeTextColor = getColor(
        colors?.activeText ? colors.activeText : "n900"
    );
    const hoverBGColor = getColor(colors?.hoverBG ? colors.hoverBG : "n30");
    const hoverTextColor = getColor(
        colors?.hoverText ? colors.hoverText : "n900"
    );
    const isActive = index === currentTab;

    return css`
        cursor: pointer;
        background-color: ${isActive ? activeBGColor : defaultBGColor};
        color: ${isActive ? activeTextColor : defaultTextColor};
        font-size: 1.25rem;
        border-radius: 50px;
        box-sizing: border-box;
        background-clip: padding-box;
        padding: 10px 30px;
        appearance: none;
        border-style: solid;
        border-width: 2px;
        border-color: transparent;
        font-family: var(--bxp-charlie-display-font-family);
        letter-spacing: 0.04rem;

        &.select {
            margin: 0 auto;
            display: block;
            width: 100%;
        }
        &:hover,
        &:focus {
            background-color: ${isActive ? activeBGColor : hoverBGColor};
            color: ${isActive ? activeTextColor : hoverTextColor};
            border-color: ${isActive ? activeBGColor : "transparent"};
        }

        &:focus-visible {
            outline: 0;
            border-color: ${activeBGColor};
        }
        &:active {
            border-color: ${hoverBGColor};
        }

        ${UNSAFE_media.below.md} {
            font-size: 0.85rem;
        }
    `;
};
